/* --- tooltip ------------------------------------------------------------- */

.tooltip {
  z-index: var(--z-dropdown);
  max-width: 280px;
  padding: var(--space-2) var(--space-3);
  background: var(--color-text-primary);
  color: var(--color-canvas);
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  line-height: var(--text-sm-line);
  box-shadow: var(--shadow-medium);
  /* The inverse surface is deliberate: a tooltip that matches the page reads as
   * part of it, and a tooltip's whole job is to look temporary. */
}

/* --- dialog --------------------------------------------------------------- */

.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--z-overlay);
  background: var(--color-overlay-backdrop);
  animation: fade var(--duration-fast) var(--easing-decelerate);
}

.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: var(--z-dialog);
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  width: calc(100vw - var(--space-7));
  max-height: calc(100vh - var(--space-8));
  padding: var(--space-6);
  overflow: auto;
  background: var(--color-surface-raised);
  border: var(--border-width-thin) solid var(--color-border-default);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-high);
  transform: translate(-50%, -50%);
  animation: fade var(--duration-fast) var(--easing-decelerate);
}

.sm {
  max-width: 440px;
}

.md {
  max-width: 640px;
}

.dialogHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
}

.dialogTitle {
  font-size: var(--text-lg);
  line-height: var(--text-lg-line);
  font-weight: var(--font-weight-semibold);
  letter-spacing: -0.01em;
}

.dialogDescription {
  margin-top: calc(var(--space-4) * -1 + var(--space-1));
  font-size: var(--text-base);
  line-height: var(--text-base-line);
  color: var(--color-text-secondary);
  text-wrap: pretty;
}

.dialogBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.dialogFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-3);
  padding-top: var(--space-4);
  margin-top: var(--space-2);
  border-top: var(--border-width-thin) solid var(--color-border-default);
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

/* --- menu ------------------------------------------------------------------ */

.menu {
  z-index: var(--z-dropdown);
  min-width: 200px;
  max-height: var(--radix-dropdown-menu-content-available-height);
  padding: var(--space-1);
  overflow: auto;
  background: var(--color-surface-raised);
  border: var(--border-width-thin) solid var(--color-border-default);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-medium);
}

.menuItem {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: var(--row-height);
  padding: 0 var(--space-3);
  border-radius: var(--radius-sm);
  font-size: var(--text-base);
  color: var(--color-text-primary);
  cursor: pointer;
  user-select: none;
}

.menuItem[data-highlighted] {
  background: var(--color-surface-hover);
  outline: none;
}

.menuItem[data-disabled] {
  color: var(--color-text-tertiary);
  pointer-events: none;
}

.menuItemDanger {
  color: var(--color-danger-fg);
}

.menuItemIcon {
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 14px;
  color: var(--color-text-tertiary);
}

/* The idle icon is hidden while the radio indicator is showing, so the two
 * never occupy the same 14px at once. */
.menuItem[data-state="checked"] .menuItemIconIdle {
  display: none;
}

.menuItem[data-state="checked"] .menuItemIcon {
  color: var(--color-accent-fg);
}

.menuItemLabel {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menuItemShortcut {
  flex: none;
  padding: 0 var(--space-2);
  border: var(--border-width-thin) solid var(--color-border-default);
  border-radius: var(--radius-sm);
  font-family: var(--font-family-ui);
  font-size: var(--text-xs);
  color: var(--color-text-tertiary);
}

.menuSeparator {
  height: var(--border-width-thin);
  margin: var(--space-1) 0;
  background: var(--color-border-default);
}

.menuLabel {
  padding: var(--space-3) var(--space-3) var(--space-2);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-tertiary);
}
